exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-72559d82]{color:#fff;font-size:24px;margin-bottom:40px}.body[data-v-72559d82]{background-color:#fff;padding:20px 0;margin:0 auto}.body .belt-btn[data-v-72559d82]{margin-top:20px}.row[data-v-72559d82]{margin:0}.rank[data-v-72559d82]{margin-top:3.5rem}.italia input[data-v-72559d82]{width:25px}.my-alert[data-v-72559d82]{background-color:var(--red);text-align:center;padding:8px;margin:15px}.area-no[data-v-72559d82]{position:relative}.suggestions[data-v-72559d82]{border:1px solid #000;position:absolute;height:20px;right:120px;bottom:-20px;z-index:10}@media (min-width:576px){.body[data-v-72559d82]{padding:20px}}", ""]);

// exports
